import { API } from "../../App";

export const MANAGE_ROLES = ["admin", "company_owner", "site_manager"];

export async function handoverApi(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}/handover${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      ...(body ? { "Content-Type": "application/json" } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = Array.isArray(data.detail) ? "Please check the details entered" : data.detail;
    throw new Error(detail || "Something went wrong");
  }
  return data;
}

export const clientLabel = (client) => {
  if (!client) return null;
  if (client.client_type === "developer") return client.developer?.company_name || "Developer";
  return client.purchaser?.name || "Purchaser";
};

export const naturalSort = (a, b) =>
  a.dwelling_number.localeCompare(b.dwelling_number, undefined, { numeric: true, sensitivity: "base" });
